import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';

export default class RelatedLessonPlan {
  oninit(vnode) {
    this.related_lesson_plan = vnode.attrs.related_lesson_plan;
  }
  view() {
    const related_lesson_plan = this.related_lesson_plan;
    return (
      <Link className="d-flex" href={app.route.lesson_plan(related_lesson_plan.id)} target="_blank">
        <div>
          {m('img', {
            src: app.forum.attribute('baseUrl') + '/' + related_lesson_plan.thumbnail,
            alt: related_lesson_plan.title,
            width: 75,
            class: 'rounded',
          })}
        </div>
        <div>
          <span className={`tag tag-${app.translator.trans('td-lesson-plans.lib.agegroup_classes.' + related_lesson_plan.age_group)}`}>
            {app.translator.trans('td-lesson-plans.lib.agegroup.' + related_lesson_plan.age_group)}
          </span>
          <div>{related_lesson_plan.title}</div>
        </div>
      </Link>
    );
  }
}
